import React from "react";
import { deleteDraft } from "../../store/actions/precog";
import { useDispatch } from "react-redux";
import { Button, Modal } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import InvoiceBlock from "./toBeAccountantContent/invoiceBlock";
import { openNotificationWithIcon } from "../../libs/utils";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";

const DeleteModal = ({visible, onClose, onClick, spinnerDelete, setSpinnerDelete, 
  setOpenDeleteModal, data, index, selectedDocuments, setSelectedDocuments,
  allDocumentsSelected, setAllDocumentsSelected, navigateTo}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <Modal
        visible={visible}
        closable={true}
        backdrop={false}
        onClose={onClose}
        footer={
          <div className="split-article-footer">
            <div style={{display: "flex", gap: 12}}>
              <Button
                kind="secondary"
                onClick={onClick}
              >
                    Annulla
              </Button>
              <div>
                <Button
                  kind="primary"
                  onClick={() => {
                    if (spinnerDelete) return;
                    if (navigateTo) navigate("/precog");
                    setSpinnerDelete(true);
                    dispatch(deleteDraft(data?.id)).then(() => {
                      setSpinnerDelete(false);
                      // chiudo il drawer
                      setOpenDeleteModal(false);
                      openNotificationWithIcon(
                        notification,
                        "success",
                        "",
                        "Movimento eliminato correttamente",
                        null,
                        null
                      );
                    }).catch(e => {
                      setSpinnerDelete(false);
                      openNotificationWithIcon(
                        notification,
                        "error",
                        "",
                        e,
                        null,
                        null
                      );
                    });
                  }}
                >
                  {spinnerDelete ?
                    <FontAwesomeIcon icon={["far", "circle-notch"]} style={{fontSize: "18px"}} spin />
                    : "Elimina"
                  }
                </Button>
              </div>
            </div>
          </div>
        }
        title={`Elimina ${
          (data?.doc?.source || data?.source) === "MANUAL" &&  (data?.reasonId === "PF1" || data?.reasonId === "RF1" || data?.reasonId === "PAF1" || data?.reasonId === "RAC1") ? "Movimenti finanziari"
            :  (data?.doc?.source || data?.source) === "MANUAL" && (data?.reasonId === "CG1" || data?.reasonId === "RG1") ? "Altri movimenti"
              :
              data?.reasonId === "GD" ? "Nuovo documento" : (data?.doc?.factType || data?.factType) === "INVOICE" ?
                `Fattura di ${(data?.doc?.active) ? "vendita" : "acquisto"}`
                : (data?.doc?.factType || data?.factType) === "RECEIPT" ?
                  <FormattedMessage id="preCog.accountingTab.receiptType"/>
                  : "Movimento bancario"
  
        }`}
      >
        <div style={{ zIndex: "9999", width: "55vw", margin: "20px 0" }}>
          <div style={{paddingBottom: "24px",
            letterSpacing: "0.44px",
            lineHeight: "24px",
            color: "#152935"
          }}>
            Vuoi eliminare la seguente fattura?
          </div>
          <InvoiceBlock
            data={data}
            index={index}
            selectedDocuments={selectedDocuments}
            setSelectedDocuments={setSelectedDocuments}
            allDocumentsSelected={allDocumentsSelected}
            setAllDocumentsSelected={setAllDocumentsSelected}
            allWidth={true}
            hideCheckbox={true}
          />
        </div>   
      </Modal>
    </>
  );
};

export default DeleteModal;